import request from '@/utils/request'
import { MenuItemLinkType } from './menu'
import { ApiResponse } from './types'

export interface BannerResponse {
  bannerList: Banner[]
}

export interface Banner {
  id: number
  imageUrl: string
  videoUrl: string
  title: string
  description: string
  linkType: MenuItemLinkType
  linkUrl: string
  sortNum: number
}

export const queryPageBanner = async (pageCode: string) => {
  return await request.post<ApiResponse<BannerResponse>>('/api/portalWebsiteSvcExt/banners', {
    pageCode
  })
}

export interface ModulesResponse {
  moduleList: Module[]
}
export enum PortalPositionEnum {
  Left = 1,
  Center = 2,
  Right = 3
}

export interface PageModuleOutputDto {
  [key: string]: unknown
}

export interface Module {
  id: number
  moduleCode: string
  displayModeName: string
  displayModeCode: string
  mainTitle: string
  subTitle: string
  linkText: string
  linkUrl: string
  position: PortalPositionEnum
  fontSize: number
  isBold: boolean
  sortNum: number
  fieldData: PageModuleOutputDto[]
  items: Module[]
}

export const queryPageSection = async (pageCode: string) => {
  return await request.post<ApiResponse<ModulesResponse>>('/api/portalWebsiteSvcExt/pageModules', {
    pageCode
  })
}
